import {Component} from 'react';
import h from 'react-hyperscript';
import Avatar from 'Components/Header/Avatar/Avatar';
import GoogLogoutButton from
  'Components/Buttons/GoogLogoutButton/GoogLogoutButton';
import GoogLoginButton from
  'Components/Buttons/GoogLoginButton/GoogLoginButton';

class MobileNavLoggedIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSettingsOpen: this.props.needsDistrictConfig,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      if (this.props.needsDistrictConfig) {
        this.handleSettingsOpen();
      }
    }
  }

  handleDialogClose() {
    this.setState({
      isSettingsOpen: false,
    });
  }

  handleSettingsOpen() {
    this.setState({
      isSettingsOpen: true,
    });
  }

  render() {
    if (this.props.userStatus) {
      return (
        h('div', {
          id: 'mobile-nav--logged-in',
          key: 'mobile-nav--logged-i',
          className: 'mobile-nav__auth-info',
        }, [
          h('div', {
            id: 'mobile-nav__settings',
            key: 'mobile-nav__settings',
            className: 'flex flex--space-between--all padding-bottom--md',
          }, [
            h('p', {
              id: 'mobile-nav__district-name',
              key: 'mobile-nav__district-name',
              className: 'header__district-name text--grey',
            }, this.props.userStatus.district_name),
            this.props.isAdmin ? h('a', {
              href: '#',
              className: 'material-icons text--grey',
              onClick: (e) => {
                e.preventDefault();
                this.props.handleMenuClose();
                this.props.handleSettingsOpen();
              },
            }, 'settings') : null,
          ]),

          h('div', {
            id: 'mobile-nav__auth-details',
            key: 'mobile-nav__auth-details',
            className: 'flex flex--space-between flex--align-start',
          }, [

            h(Avatar, {
              id: 'mobile-nav__avatar',
              key: 'mobile-nav__avatar',
              width: '32px',
              image: this.props.googleUser.getBasicProfile().getImageUrl(),
            }, null),

            h('div', {
              id: 'mobile-nav__avatar--left',
              key: 'mobile-nav__avatar--left',
              className: 'col-ratio-2',
            }, [

              h('p', {
                key: 'profile-menu__name',
                className: 'header__menu-text',
              }, this.props.googleUser.getBasicProfile().getName()),

              h('p', {
                id: 'mobile-nav__email',
                key: 'mobile-nav__email',
                className: 'text--grey truncate--1 margin-bottom--micro',
              }, this.props.googleUser.getBasicProfile().getEmail()),

              h(GoogLogoutButton, {
                key: 'mobile-nav__logout',
                id: `mobile-nav__logout`,
                className: 'text--grey text--underlined',
                onClick: this.props.logoutClick,
              }, null),
            ]),
          ]),
        ])
      );
    } else {
      return (
        h('div', {
          id: 'mobile-nav--logged-out',
          className: 'mobile-nav__auth-info',
        }, h(GoogLoginButton, {
          id: this.props.loginBtnId,
          onClick: this.props.loginClick,
        }, null))
      );
    }
  }
}
export default MobileNavLoggedIn;
